"use strict";
// tslint:disable
/**
 * Movie Revenue Estimation
 * Collection of methods surrounding movies revenue estimation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const url = require("url");
const portableFetch = require("portable-fetch");
const BASE_PATH = "https://localhost/api".replace(/\/+$/, "");
/**
 *
 * @export
 */
exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
class BaseAPI {
    constructor(configuration, basePath = BASE_PATH, fetch = portableFetch) {
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
exports.BaseAPI = BaseAPI;
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        this.field = field;
    }
}
exports.RequiredError = RequiredError;
/**
 * AutocompleteApi - fetch parameter creator
 * @export
 */
exports.AutocompleteApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {AutocompleteSearchText} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoCompleteResultsForAMovieTitle(payload, X_Fields, options = {}) {
            // verify required parameter 'payload' is not null or undefined
            if (payload === null || payload === undefined) {
                throw new RequiredError('payload', 'Required parameter payload was null or undefined when calling getAutoCompleteResultsForAMovieTitle.');
            }
            const localVarPath = `/autocomplete/movie_title`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (X_Fields !== undefined && X_Fields !== null) {
                localVarHeaderParameter['X-Fields'] = String(X_Fields);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AutocompleteSearchText" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(payload || {}) : (payload || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {AutocompleteSearchText} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutocompleteResultsForCast(payload, X_Fields, options = {}) {
            // verify required parameter 'payload' is not null or undefined
            if (payload === null || payload === undefined) {
                throw new RequiredError('payload', 'Required parameter payload was null or undefined when calling getAutocompleteResultsForCast.');
            }
            const localVarPath = `/autocomplete/cast`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (X_Fields !== undefined && X_Fields !== null) {
                localVarHeaderParameter['X-Fields'] = String(X_Fields);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AutocompleteSearchText" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(payload || {}) : (payload || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {AutocompleteSearchText} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutocompleteResultsForCrew(payload, X_Fields, options = {}) {
            // verify required parameter 'payload' is not null or undefined
            if (payload === null || payload === undefined) {
                throw new RequiredError('payload', 'Required parameter payload was null or undefined when calling getAutocompleteResultsForCrew.');
            }
            const localVarPath = `/autocomplete/crew`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (X_Fields !== undefined && X_Fields !== null) {
                localVarHeaderParameter['X-Fields'] = String(X_Fields);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AutocompleteSearchText" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(payload || {}) : (payload || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {AutocompleteRol} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutocompleteResultsForCrewJob(payload, X_Fields, options = {}) {
            // verify required parameter 'payload' is not null or undefined
            if (payload === null || payload === undefined) {
                throw new RequiredError('payload', 'Required parameter payload was null or undefined when calling getAutocompleteResultsForCrewJob.');
            }
            const localVarPath = `/autocomplete/crew_role`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (X_Fields !== undefined && X_Fields !== null) {
                localVarHeaderParameter['X-Fields'] = String(X_Fields);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AutocompleteRol" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(payload || {}) : (payload || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {AutocompleteSearchText} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutocompleteResultsForGenres(payload, X_Fields, options = {}) {
            // verify required parameter 'payload' is not null or undefined
            if (payload === null || payload === undefined) {
                throw new RequiredError('payload', 'Required parameter payload was null or undefined when calling getAutocompleteResultsForGenres.');
            }
            const localVarPath = `/autocomplete/genre`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (X_Fields !== undefined && X_Fields !== null) {
                localVarHeaderParameter['X-Fields'] = String(X_Fields);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AutocompleteSearchText" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(payload || {}) : (payload || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {AutocompleteSearchText} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutocompleteResultsForKeywords(payload, X_Fields, options = {}) {
            // verify required parameter 'payload' is not null or undefined
            if (payload === null || payload === undefined) {
                throw new RequiredError('payload', 'Required parameter payload was null or undefined when calling getAutocompleteResultsForKeywords.');
            }
            const localVarPath = `/autocomplete/keyword`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (X_Fields !== undefined && X_Fields !== null) {
                localVarHeaderParameter['X-Fields'] = String(X_Fields);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("AutocompleteSearchText" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(payload || {}) : (payload || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AutocompleteApi - functional programming interface
 * @export
 */
exports.AutocompleteApiFp = function (configuration) {
    return {
        /**
         *
         * @param {AutocompleteSearchText} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoCompleteResultsForAMovieTitle(payload, X_Fields, options) {
            const localVarFetchArgs = exports.AutocompleteApiFetchParamCreator(configuration).getAutoCompleteResultsForAMovieTitle(payload, X_Fields, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {AutocompleteSearchText} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutocompleteResultsForCast(payload, X_Fields, options) {
            const localVarFetchArgs = exports.AutocompleteApiFetchParamCreator(configuration).getAutocompleteResultsForCast(payload, X_Fields, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {AutocompleteSearchText} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutocompleteResultsForCrew(payload, X_Fields, options) {
            const localVarFetchArgs = exports.AutocompleteApiFetchParamCreator(configuration).getAutocompleteResultsForCrew(payload, X_Fields, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {AutocompleteRol} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutocompleteResultsForCrewJob(payload, X_Fields, options) {
            const localVarFetchArgs = exports.AutocompleteApiFetchParamCreator(configuration).getAutocompleteResultsForCrewJob(payload, X_Fields, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {AutocompleteSearchText} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutocompleteResultsForGenres(payload, X_Fields, options) {
            const localVarFetchArgs = exports.AutocompleteApiFetchParamCreator(configuration).getAutocompleteResultsForGenres(payload, X_Fields, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {AutocompleteSearchText} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutocompleteResultsForKeywords(payload, X_Fields, options) {
            const localVarFetchArgs = exports.AutocompleteApiFetchParamCreator(configuration).getAutocompleteResultsForKeywords(payload, X_Fields, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * AutocompleteApi - factory interface
 * @export
 */
exports.AutocompleteApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {AutocompleteSearchText} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoCompleteResultsForAMovieTitle(payload, X_Fields, options) {
            return exports.AutocompleteApiFp(configuration).getAutoCompleteResultsForAMovieTitle(payload, X_Fields, options)(fetch, basePath);
        },
        /**
         *
         * @param {AutocompleteSearchText} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutocompleteResultsForCast(payload, X_Fields, options) {
            return exports.AutocompleteApiFp(configuration).getAutocompleteResultsForCast(payload, X_Fields, options)(fetch, basePath);
        },
        /**
         *
         * @param {AutocompleteSearchText} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutocompleteResultsForCrew(payload, X_Fields, options) {
            return exports.AutocompleteApiFp(configuration).getAutocompleteResultsForCrew(payload, X_Fields, options)(fetch, basePath);
        },
        /**
         *
         * @param {AutocompleteRol} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutocompleteResultsForCrewJob(payload, X_Fields, options) {
            return exports.AutocompleteApiFp(configuration).getAutocompleteResultsForCrewJob(payload, X_Fields, options)(fetch, basePath);
        },
        /**
         *
         * @param {AutocompleteSearchText} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutocompleteResultsForGenres(payload, X_Fields, options) {
            return exports.AutocompleteApiFp(configuration).getAutocompleteResultsForGenres(payload, X_Fields, options)(fetch, basePath);
        },
        /**
         *
         * @param {AutocompleteSearchText} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutocompleteResultsForKeywords(payload, X_Fields, options) {
            return exports.AutocompleteApiFp(configuration).getAutocompleteResultsForKeywords(payload, X_Fields, options)(fetch, basePath);
        },
    };
};
/**
 * AutocompleteApi - object-oriented interface
 * @export
 * @class AutocompleteApi
 * @extends {BaseAPI}
 */
class AutocompleteApi extends BaseAPI {
    /**
     *
     * @param {AutocompleteSearchText} payload
     * @param {string} [X_Fields] An optional fields mask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutocompleteApi
     */
    getAutoCompleteResultsForAMovieTitle(payload, X_Fields, options) {
        return exports.AutocompleteApiFp(this.configuration).getAutoCompleteResultsForAMovieTitle(payload, X_Fields, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {AutocompleteSearchText} payload
     * @param {string} [X_Fields] An optional fields mask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutocompleteApi
     */
    getAutocompleteResultsForCast(payload, X_Fields, options) {
        return exports.AutocompleteApiFp(this.configuration).getAutocompleteResultsForCast(payload, X_Fields, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {AutocompleteSearchText} payload
     * @param {string} [X_Fields] An optional fields mask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutocompleteApi
     */
    getAutocompleteResultsForCrew(payload, X_Fields, options) {
        return exports.AutocompleteApiFp(this.configuration).getAutocompleteResultsForCrew(payload, X_Fields, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {AutocompleteRol} payload
     * @param {string} [X_Fields] An optional fields mask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutocompleteApi
     */
    getAutocompleteResultsForCrewJob(payload, X_Fields, options) {
        return exports.AutocompleteApiFp(this.configuration).getAutocompleteResultsForCrewJob(payload, X_Fields, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {AutocompleteSearchText} payload
     * @param {string} [X_Fields] An optional fields mask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutocompleteApi
     */
    getAutocompleteResultsForGenres(payload, X_Fields, options) {
        return exports.AutocompleteApiFp(this.configuration).getAutocompleteResultsForGenres(payload, X_Fields, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {AutocompleteSearchText} payload
     * @param {string} [X_Fields] An optional fields mask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutocompleteApi
     */
    getAutocompleteResultsForKeywords(payload, X_Fields, options) {
        return exports.AutocompleteApiFp(this.configuration).getAutocompleteResultsForKeywords(payload, X_Fields, options)(this.fetch, this.basePath);
    }
}
exports.AutocompleteApi = AutocompleteApi;
/**
 * InfoApi - fetch parameter creator
 * @export
 */
exports.InfoApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {MovieInfoInput} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInformationAboutAMovie(payload, X_Fields, options = {}) {
            // verify required parameter 'payload' is not null or undefined
            if (payload === null || payload === undefined) {
                throw new RequiredError('payload', 'Required parameter payload was null or undefined when calling getInformationAboutAMovie.');
            }
            const localVarPath = `/info/movie_info`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (X_Fields !== undefined && X_Fields !== null) {
                localVarHeaderParameter['X-Fields'] = String(X_Fields);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("MovieInfoInput" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(payload || {}) : (payload || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * InfoApi - functional programming interface
 * @export
 */
exports.InfoApiFp = function (configuration) {
    return {
        /**
         *
         * @param {MovieInfoInput} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInformationAboutAMovie(payload, X_Fields, options) {
            const localVarFetchArgs = exports.InfoApiFetchParamCreator(configuration).getInformationAboutAMovie(payload, X_Fields, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * InfoApi - factory interface
 * @export
 */
exports.InfoApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {MovieInfoInput} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInformationAboutAMovie(payload, X_Fields, options) {
            return exports.InfoApiFp(configuration).getInformationAboutAMovie(payload, X_Fields, options)(fetch, basePath);
        },
    };
};
/**
 * InfoApi - object-oriented interface
 * @export
 * @class InfoApi
 * @extends {BaseAPI}
 */
class InfoApi extends BaseAPI {
    /**
     *
     * @param {MovieInfoInput} payload
     * @param {string} [X_Fields] An optional fields mask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoApi
     */
    getInformationAboutAMovie(payload, X_Fields, options) {
        return exports.InfoApiFp(this.configuration).getInformationAboutAMovie(payload, X_Fields, options)(this.fetch, this.basePath);
    }
}
exports.InfoApi = InfoApi;
/**
 * LoginApi - fetch parameter creator
 * @export
 */
exports.LoginApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {UserInfo} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginForTheUser(payload, X_Fields, options = {}) {
            // verify required parameter 'payload' is not null or undefined
            if (payload === null || payload === undefined) {
                throw new RequiredError('payload', 'Required parameter payload was null or undefined when calling loginForTheUser.');
            }
            const localVarPath = `/auth/login`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (X_Fields !== undefined && X_Fields !== null) {
                localVarHeaderParameter['X-Fields'] = String(X_Fields);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("UserInfo" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(payload || {}) : (payload || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LoginApi - functional programming interface
 * @export
 */
exports.LoginApiFp = function (configuration) {
    return {
        /**
         *
         * @param {UserInfo} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginForTheUser(payload, X_Fields, options) {
            const localVarFetchArgs = exports.LoginApiFetchParamCreator(configuration).loginForTheUser(payload, X_Fields, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * LoginApi - factory interface
 * @export
 */
exports.LoginApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {UserInfo} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginForTheUser(payload, X_Fields, options) {
            return exports.LoginApiFp(configuration).loginForTheUser(payload, X_Fields, options)(fetch, basePath);
        },
    };
};
/**
 * LoginApi - object-oriented interface
 * @export
 * @class LoginApi
 * @extends {BaseAPI}
 */
class LoginApi extends BaseAPI {
    /**
     *
     * @param {UserInfo} payload
     * @param {string} [X_Fields] An optional fields mask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    loginForTheUser(payload, X_Fields, options) {
        return exports.LoginApiFp(this.configuration).loginForTheUser(payload, X_Fields, options)(this.fetch, this.basePath);
    }
}
exports.LoginApi = LoginApi;
/**
 * PredictionApi - fetch parameter creator
 * @export
 */
exports.PredictionApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {PredictionDeleteInfo} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePredictionData(payload, X_Fields, options = {}) {
            // verify required parameter 'payload' is not null or undefined
            if (payload === null || payload === undefined) {
                throw new RequiredError('payload', 'Required parameter payload was null or undefined when calling deletePredictionData.');
            }
            const localVarPath = `/prediction/getpredictiondata`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (X_Fields !== undefined && X_Fields !== null) {
                localVarHeaderParameter['X-Fields'] = String(X_Fields);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("PredictionDeleteInfo" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(payload || {}) : (payload || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredictionData(X_Fields, options = {}) {
            const localVarPath = `/prediction/getpredictiondata`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (X_Fields !== undefined && X_Fields !== null) {
                localVarHeaderParameter['X-Fields'] = String(X_Fields);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {MovieInfoOutput} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredictionForMovie(payload, X_Fields, options = {}) {
            // verify required parameter 'payload' is not null or undefined
            if (payload === null || payload === undefined) {
                throw new RequiredError('payload', 'Required parameter payload was null or undefined when calling getPredictionForMovie.');
            }
            const localVarPath = `/prediction/movie`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (X_Fields !== undefined && X_Fields !== null) {
                localVarHeaderParameter['X-Fields'] = String(X_Fields);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("MovieInfoOutput" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(payload || {}) : (payload || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SaveMoviePrediction} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAPredictionForAMovie(payload, X_Fields, options = {}) {
            // verify required parameter 'payload' is not null or undefined
            if (payload === null || payload === undefined) {
                throw new RequiredError('payload', 'Required parameter payload was null or undefined when calling saveAPredictionForAMovie.');
            }
            const localVarPath = `/prediction/savemovie`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (X_Fields !== undefined && X_Fields !== null) {
                localVarHeaderParameter['X-Fields'] = String(X_Fields);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("SaveMoviePrediction" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(payload || {}) : (payload || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PredictionApi - functional programming interface
 * @export
 */
exports.PredictionApiFp = function (configuration) {
    return {
        /**
         *
         * @param {PredictionDeleteInfo} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePredictionData(payload, X_Fields, options) {
            const localVarFetchArgs = exports.PredictionApiFetchParamCreator(configuration).deletePredictionData(payload, X_Fields, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredictionData(X_Fields, options) {
            const localVarFetchArgs = exports.PredictionApiFetchParamCreator(configuration).getPredictionData(X_Fields, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {MovieInfoOutput} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredictionForMovie(payload, X_Fields, options) {
            const localVarFetchArgs = exports.PredictionApiFetchParamCreator(configuration).getPredictionForMovie(payload, X_Fields, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {SaveMoviePrediction} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAPredictionForAMovie(payload, X_Fields, options) {
            const localVarFetchArgs = exports.PredictionApiFetchParamCreator(configuration).saveAPredictionForAMovie(payload, X_Fields, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * PredictionApi - factory interface
 * @export
 */
exports.PredictionApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {PredictionDeleteInfo} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePredictionData(payload, X_Fields, options) {
            return exports.PredictionApiFp(configuration).deletePredictionData(payload, X_Fields, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredictionData(X_Fields, options) {
            return exports.PredictionApiFp(configuration).getPredictionData(X_Fields, options)(fetch, basePath);
        },
        /**
         *
         * @param {MovieInfoOutput} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredictionForMovie(payload, X_Fields, options) {
            return exports.PredictionApiFp(configuration).getPredictionForMovie(payload, X_Fields, options)(fetch, basePath);
        },
        /**
         *
         * @param {SaveMoviePrediction} payload
         * @param {string} [X_Fields] An optional fields mask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAPredictionForAMovie(payload, X_Fields, options) {
            return exports.PredictionApiFp(configuration).saveAPredictionForAMovie(payload, X_Fields, options)(fetch, basePath);
        },
    };
};
/**
 * PredictionApi - object-oriented interface
 * @export
 * @class PredictionApi
 * @extends {BaseAPI}
 */
class PredictionApi extends BaseAPI {
    /**
     *
     * @param {PredictionDeleteInfo} payload
     * @param {string} [X_Fields] An optional fields mask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredictionApi
     */
    deletePredictionData(payload, X_Fields, options) {
        return exports.PredictionApiFp(this.configuration).deletePredictionData(payload, X_Fields, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [X_Fields] An optional fields mask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredictionApi
     */
    getPredictionData(X_Fields, options) {
        return exports.PredictionApiFp(this.configuration).getPredictionData(X_Fields, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {MovieInfoOutput} payload
     * @param {string} [X_Fields] An optional fields mask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredictionApi
     */
    getPredictionForMovie(payload, X_Fields, options) {
        return exports.PredictionApiFp(this.configuration).getPredictionForMovie(payload, X_Fields, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {SaveMoviePrediction} payload
     * @param {string} [X_Fields] An optional fields mask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredictionApi
     */
    saveAPredictionForAMovie(payload, X_Fields, options) {
        return exports.PredictionApiFp(this.configuration).saveAPredictionForAMovie(payload, X_Fields, options)(this.fetch, this.basePath);
    }
}
exports.PredictionApi = PredictionApi;



//////////////////
// WEBPACK FOOTER
// ./typescript_client/dist/api.js
// module id = 384
// module chunks = 0